import { OmbudsmanSimulation } from '../types/workspace';

export const mockSimulations: OmbudsmanSimulation[] = [
  // Most recent simulation for sig-12345
  {
    id: 'sim-001-v3',
    title: 'Claim denial - water damage not covered under policy terms',
    productType: 'home_buildings',
    predicted_outcome: 'upheld',
    confidence_score: 0.87,
    created_at: '2025-09-30T14:22:00Z',
    updated_at: '2025-09-30T14:22:00Z',
    signal: {
      signal_id: 'sig-12345',
      reference_number: 'REF-2025-12345',
    },
    reasoning: 'Customer provided evidence of gradual damage which should have been covered under buildings insurance. Policy wording was ambiguous regarding exclusions.',
    status: 'completed',
  },
  // Second simulation for same signal
  {
    id: 'sim-001-v2',
    title: 'Claim denial - water damage not covered under policy terms',
    productType: 'home_buildings',
    predicted_outcome: 'not_upheld',
    confidence_score: 0.72,
    created_at: '2025-09-29T10:15:00Z',
    updated_at: '2025-09-29T10:15:00Z',
    signal: {
      signal_id: 'sig-12345',
      reference_number: 'REF-2025-12345',
    },
    reasoning: 'Initial assessment suggested policy exclusions were applicable. Further review changed this determination.',
    status: 'completed',
  },
  // Original simulation for same signal
  {
    id: 'sim-001-v1',
    title: 'Claim denial - water damage not covered under policy terms',
    productType: 'home_buildings',
    predicted_outcome: 'unknown',
    confidence_score: 0.45,
    created_at: '2025-09-28T10:30:00Z',
    updated_at: '2025-09-28T10:30:00Z',
    signal: {
      signal_id: 'sig-12345',
      reference_number: 'REF-2025-12345',
    },
    reasoning: 'Insufficient information to make determination. Requested additional documentation from customer.',
    status: 'completed',
  },
  {
    id: 'sim-002',
    title: 'Premium increase at renewal - inadequate explanation provided',
    productType: 'pricing_renewals',
    predicted_outcome: 'upheld',
    confidence_score: 0.72,
    created_at: '2025-09-29T09:15:00Z',
    updated_at: '2025-09-30T11:45:00Z',
    signal: {
      signal_id: 'sig-12346',
      reference_number: 'REF-2025-12346',
    },
    reasoning: 'The firm failed to provide clear and timely communication about the reasons for the premium increase.',
    status: 'completed',
  },
  {
    id: 'sim-003',
    title: 'Motor insurance claim - disputed liability assessment',
    productType: 'motor',
    predicted_outcome: 'not_upheld',
    confidence_score: 0.91,
    created_at: '2025-09-27T16:20:00Z',
    updated_at: '2025-09-30T09:12:00Z',
    signal: {
      signal_id: 'sig-12347',
      reference_number: 'REF-2025-12347',
    },
    reasoning: 'Firm conducted thorough investigation and liability assessment was fair based on available evidence including police report and witness statements.',
    status: 'completed',
  },
  {
    id: 'sim-004',
    title: 'Travel insurance - COVID-19 cancellation claim rejected',
    productType: 'travel',
    predicted_outcome: 'upheld',
    confidence_score: 0.84,
    created_at: '2025-09-25T11:45:00Z',
    updated_at: '2025-09-29T16:30:00Z',
    signal: {
      signal_id: 'sig-12348',
      reference_number: 'REF-2025-12348',
    },
    reasoning: 'Customer cancelled due to FCDO travel advisory which should have triggered coverage. Firm incorrectly applied exclusion clause.',
    status: 'completed',
  },
  {
    id: 'sim-005',
    title: 'Medical insurance pre-authorization delay causing treatment postponement',
    productType: 'medical',
    predicted_outcome: 'upheld',
    confidence_score: 0.79,
    created_at: '2025-09-26T13:10:00Z',
    updated_at: '2025-09-30T10:05:00Z',
    signal: {
      signal_id: 'sig-12349',
      reference_number: 'REF-2025-12349',
    },
    reasoning: 'Excessive delay in pre-authorization process caused customer distress and medical complications. Firm failed to meet reasonable service standards.',
    status: 'completed',
  },
  {
    id: 'sim-006',
    title: 'Mobile phone insurance - screen damage claim denied',
    productType: 'mobile_gadget',
    predicted_outcome: 'not_upheld',
    confidence_score: 0.88,
    created_at: '2025-09-28T08:30:00Z',
    updated_at: '2025-09-30T08:15:00Z',
    signal: {
      signal_id: 'sig-12350',
      reference_number: 'REF-2025-12350',
    },
    reasoning: 'Evidence shows damage was pre-existing before policy inception. Firm acted fairly in declining the claim.',
    status: 'completed',
  },
  {
    id: 'sim-007',
    title: 'Legal expenses - solicitor fee dispute',
    productType: 'legal_expenses',
    predicted_outcome: 'not_upheld',
    confidence_score: 0.65,
    created_at: '2025-09-24T14:00:00Z',
    updated_at: '2025-09-29T12:20:00Z',
    reasoning: 'Policy clearly outlined fee limits and claim process. Customer was provided with policy documentation at inception.',
    status: 'completed',
  },
  {
    id: 'sim-008',
    title: 'Wedding insurance - venue cancellation not refunded',
    productType: 'wedding_events',
    predicted_outcome: 'upheld',
    confidence_score: 0.82,
    created_at: '2025-09-23T10:15:00Z',
    updated_at: '2025-09-28T15:40:00Z',
    signal: {
      signal_id: 'sig-12351',
      reference_number: 'REF-2025-12351',
    },
    reasoning: 'Venue cancelled due to unforeseen circumstances which was clearly covered under policy terms. Firm unreasonably denied claim.',
    status: 'completed',
  },
  {
    id: 'sim-009',
    title: 'Motor insurance - renewal quote significantly higher than comparison sites',
    productType: 'motor',
    predicted_outcome: 'not_upheld',
    confidence_score: 0.76,
    created_at: '2025-09-30T09:00:00Z',
    updated_at: '2025-09-30T12:30:00Z',
    reasoning: 'Firm provided clear explanation of pricing factors. Customer free to shop around. No unfair treatment identified.',
    status: 'completed',
  },
  {
    id: 'sim-010',
    title: 'Home insurance - subsidence claim assessment taking excessive time',
    productType: 'home_buildings',
    predicted_outcome: 'upheld',
    confidence_score: 0.68,
    created_at: '2025-09-22T11:30:00Z',
    updated_at: '2025-09-27T16:15:00Z',
    signal: {
      signal_id: 'sig-12352',
      reference_number: 'REF-2025-12352',
    },
    reasoning: 'Firm failed to provide adequate updates to customer during assessment period, causing unnecessary distress.',
    status: 'completed',
  },
  {
    id: 'sim-011',
    title: 'Marine insurance - yacht damage claim',
    productType: 'marine',
    predicted_outcome: 'unknown',
    confidence_score: 0.45,
    created_at: '2025-09-30T15:00:00Z',
    updated_at: '2025-09-30T15:30:00Z',
    reasoning: 'Insufficient evidence provided to make a determination. Awaiting survey report and additional documentation.',
    status: 'draft',
  },
];

/**
 * Get simulations by status
 */
export const getSimulationsByStatus = (status: 'draft' | 'completed' | 'archived') => {
  return mockSimulations.filter(sim => sim.status === status);
};

/**
 * Get simulations by outcome
 */
export const getSimulationsByOutcome = (outcome: string) => {
  if (outcome === 'all') return mockSimulations;
  return mockSimulations.filter(sim => sim.predicted_outcome === outcome);
};

/**
 * Get simulations by product type
 */
export const getSimulationsByProductType = (productType: string) => {
  if (productType === 'all') return mockSimulations;
  return mockSimulations.filter(sim => sim.productType === productType);
};

/**
 * Search simulations by title
 */
export const searchSimulations = (query: string) => {
  const lowerQuery = query.toLowerCase();
  return mockSimulations.filter(sim =>
    sim.title.toLowerCase().includes(lowerQuery)
  );
};
